import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as Logger from "js-logger";
import template from "./about.vue";

@Component({
  mixins: [template]
})
export default class AboutView extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/layouts/about/index.ts